export default {
  methods: {
    getToken() {
      if (document.cookie.length > 0) {
        const c_name = "ss_csrf_token";
        let c_start = document.cookie.indexOf(c_name + "=");
        if (c_start != -1) {
            c_start = c_start + c_name.length + 1;
            let c_end = document.cookie.indexOf(";" , c_start);
            if (c_end == -1) {
                c_end = document.cookie.length;
            }
            return unescape(document.cookie.substring(c_start, c_end));
        }
      }
      return "";
    }
  }
}